import { render, staticRenderFns } from "./DetailsInventairePage.vue?vue&type=template&id=378fff8e&"
import script from "../../../public/js/img/Discoveryjs/InventoryAppJs/DetailsInventaire.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/InventoryAppJs/DetailsInventaire.js?vue&type=script&lang=js&"
import style0 from "./DetailsInventairePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports